<app-card theme="secondary" class="modal">
  <app-card-header slot="header" class="modal__header">
    <svg
      (click)="onClickClose()"
      (keydown.enter)="onClickClose()"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </app-card-header>
  <app-card-content slot="content" class="modal__content">
    <div class="modal__content-body">
      <div class="modal__content-body__icon" [class.pb]="addPaddingIcon">
        <svg
          *ngIf="icon === 'spinner'"
          width="106"
          height="108"
          viewBox="0 0 106 108"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="spinner"
        >
          <ellipse
            cx="53.0009"
            cy="53.9995"
            rx="38.7431"
            ry="39.4741"
            stroke="#1681FF"
            stroke-opacity="0.25"
            stroke-width="14"
          />
          <path
            d="M52.7317 14.527C63.0068 14.4545 72.8893 18.5438 80.2051 25.8952C87.521 33.2466 91.671 43.2579 91.7421 53.7268"
            stroke="url(#paint0_linear_583_14009)"
            stroke-width="14"
            stroke-linecap="round"
            stroke-dasharray="4 4"
          />
          <defs>
            <linearGradient
              id="paint0_linear_583_14009"
              x1="86.4471"
              y1="73.9219"
              x2="18.9218"
              y2="35.1782"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#1681FF" />
              <stop
                offset="0.755208"
                stop-color="#1681FF"
                stop-opacity="0.01"
              />
              <stop offset="1" stop-color="#1681FF" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          class="modal__content-body__icon-main"
          [class.show]="icon === Type.CheckCircle"
        >
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          class="modal__content-body__icon-main"
          [class.show]="icon === Type.Info"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          class="modal__content-body__icon-main"
          [class.show]="icon === Type.Airplay"
        >
          <path
            d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
          ></path>
          <polygon points="12 15 17 21 7 21 12 15"></polygon>
        </svg>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          class="modal__content-body__icon-main"
          [class.show]="icon === Type.Download"
        >
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          class="modal__content-body__icon-main"
          [class.show]="icon === Type.Share"
        >
          <circle cx="18" cy="5" r="3"></circle>
          <circle cx="6" cy="12" r="3"></circle>
          <circle cx="18" cy="19" r="3"></circle>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
        </svg>

        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" class="modal__content-body__icon-main"
          [class.show]="icon === Type.AlertTriangle">
          <path
            d="M21.3813 11.613L8.41044 33.2669C8.14301 33.73 8.00151 34.2551 8.00001 34.7899C7.99851 35.3247 8.13707 35.8505 8.40191 36.3151C8.66674 36.7798 9.04861 37.1669 9.50953 37.4382C9.97045 37.7094 10.4944 37.8552 11.0291 37.861H36.9709C37.5056 37.8552 38.0295 37.7094 38.4905 37.4382C38.9514 37.1669 39.3333 36.7798 39.5981 36.3151C39.8629 35.8505 40.0015 35.3247 40 34.7899C39.9985 34.2551 39.857 33.73 39.5896 33.2669L26.6187 11.613C26.3457 11.1629 25.9613 10.7908 25.5026 10.5326C25.0439 10.2743 24.5264 10.1387 24 10.1387C23.4736 10.1387 22.9561 10.2743 22.4974 10.5326C22.0387 10.7908 21.6543 11.1629 21.3813 11.613V11.613Z"
            stroke="#F49A26" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M24.0005 19.4844V25.6099" stroke="#F49A26" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M24.0005 31.7363H24.0158" stroke="#F49A26" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>

      <div class="modal__content-body__title">
        <h3>{{ titleModal }}</h3>
      </div>

      <div class="modal__content-body__text">
        <p>{{ text }}</p>
      </div>

      <div class="modal__content-body__actions" [class.mt]="showActions">
        <slot name="content" (slotchange)="slotChange($event)"></slot>
        <div
          [class.show]="showActions"
          class="modal__content-body__actions-default"
        >
          <app-button
            type="primary"
            height="60px"
            (onClick)="onClickMainButton()"
            >{{ textActions?.main }}</app-button
          >
          <app-button
            type="link"
            height="auto"
            width="auto"
            fontWeight="400"
            [colorClass]="'color-secondary-500'"
            class="modal__content-body__actions-default__secondary"
            (onClick)="onClickSecondaryButton()"
            >{{ textActions?.secondary }}</app-button
          >
        </div>
      </div>
    </div>
  </app-card-content>
</app-card>
